import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import ParseHtml from 'html-react-parser';
import styled from 'styled-components';

export interface ITextElementRowProps {
	text: string;
}

export const DescriptionText = styled.div`
	border: 1px dashed ${globalVars.gray5};
	padding: 12px 12px 12px 10px;

	p {
		padding: 0;
		margin: 0;
	}
`;
DescriptionText.displayName = 'DescriptionText';

export const TextElementRow = (props: ITextElementRowProps) => {
	const { text, ...otherProps } = props;
	return <DescriptionText {...otherProps}>{ParseHtml(text)}</DescriptionText>;
};
